import posthog from 'posthog-js';

const DATA_LAYER_DEDUPE_PREFIX = 'gtm_fired_';

export function captureAnalyticsEvent(eventName, properties = {}) {
  if (!posthog.__loaded) return;
  posthog.capture(eventName, properties);
}

/**
 * Push a GTM dataLayer event. When dedupeKey is provided, the event fires at most once
 * per browser tab session for that key.
 */
export function pushDataLayerEvent(eventName, dedupeKey = null) {
  if (typeof window === 'undefined') return false;

  if (dedupeKey) {
    const storageKey = `${DATA_LAYER_DEDUPE_PREFIX}${dedupeKey}`;
    if (sessionStorage.getItem(storageKey)) return false;
    sessionStorage.setItem(storageKey, '1');
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName });
  return true;
}

export function trackPaymentCompleted(sessionId) {
  if (!sessionId) return false;
  return pushDataLayerEvent('pago_completado', `pago_completado:${sessionId}`);
}

export const FUNNEL_EVENTS = {
  LEAD_GATE_OPENED: 'lead_gate_opened',
  LEAD_GATE_ABANDONED: 'lead_gate_abandoned',
  LEAD_EMAIL_CAPTURED: 'lead_email_captured',
  LEAD_GATE_GOOGLE_CLICK: 'lead_gate_google_click',
  DEMO_MODAL_OPENED: 'demo_modal_opened',
  DEMO_LEAD_CAPTURED: 'demo_lead_captured',
  OPTRIM_WAITLIST_CAPTURED: 'optrim_waitlist_captured',
  ONBOARDING_ENTRY_VIEWED: 'onboarding_entry_viewed',
  ONBOARDING_GOOGLE_CLICK: 'onboarding_google_click',
  ONBOARDING_EMAIL_CLICK: 'onboarding_email_click',
  ONBOARDING_EXISTING_ACCOUNT_CLICK: 'onboarding_existing_account_click',
  REGISTER_WIZARD_STARTED: 'register_wizard_started',
  REGISTER_COMPLETED: 'register_completed',
  CHECKOUT_STARTED: 'checkout_started',
};

export function trackFunnelEvent(eventName, properties = {}) {
  captureAnalyticsEvent(eventName, {
    funnel: 'calculator_pricing_onboarding',
    ...properties,
  });

  const dataLayerMap = {
    [FUNNEL_EVENTS.LEAD_EMAIL_CAPTURED]: 'lead_email_captured',
    [FUNNEL_EVENTS.REGISTER_COMPLETED]: 'registro_completado_funnel',
    [FUNNEL_EVENTS.CHECKOUT_STARTED]: 'checkout_iniciado',
  };

  if (dataLayerMap[eventName]) {
    pushDataLayerEvent(dataLayerMap[eventName]);
  }
}
